import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '30%']);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  return <section id="inicio" ref={ref} className="relative h-screen min-h-[600px] w-full overflow-hidden flex items-center justify-center" data-id="element-77">
      {/* Parallax Background */}
      <motion.div style={{
      y
    }} className="absolute inset-0 w-full h-full" data-id="element-78">
        <div className="absolute inset-0 bg-charcoal/40 z-10 mix-blend-multiply" data-id="element-79" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-transparent to-charcoal/80 z-10" data-id="element-80" />
        <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=2075&q=80" alt="Luxury Real Estate Playa del Carmen" className="w-full h-full object-cover object-center scale-105" data-id="element-81" />
      </motion.div>

      {/* Content */}
      <motion.div style={{
      opacity
    }} className="relative z-20 max-w-5xl mx-auto px-6 md:px-12 text-center mt-16" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-83">
          <span className="inline-block py-1 px-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white/90 text-xs md:text-sm font-medium tracking-widest uppercase mb-6" data-id="element-84">
            Playa del Carmen, México
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-4xl md:text-6xl lg:text-7xl font-playfair text-white leading-tight mb-6 drop-shadow-lg" data-id="element-85">
          La Diferencia entre Tener una Propiedad y Tener una{' '}
          <span className="text-gold italic" data-id="element-86">Inversión Exitosa.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-white/90 font-light max-w-3xl mx-auto mb-10 leading-relaxed drop-shadow-md" data-id="element-87">
          Administración integral y ventas de alto nivel en Playa del Carmen.
          Maximizamos el valor de su patrimonio con absoluta transparencia.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8,
        ease: 'easeOut'
      }} data-id="element-88">
          <a href="https://wa.me/529843115669?text=Hola%21%20Me%20gustaria%20contactar%20a%20un%20asesor" className="group inline-flex items-center gap-3 bg-gold hover:bg-gold-hover text-white px-8 py-4 rounded-full text-lg font-medium transition-all duration-300 shadow-[0_0_20px_rgba(197,160,89,0.4)] hover:shadow-[0_0_30px_rgba(197,160,89,0.6)] hover:-translate-y-1" data-id="element-89">
            Contactar a un asesor
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-90" />
          </a>
        </motion.div>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2" data-id="element-91">
        <div className="w-[1px] h-12 bg-white/20 relative overflow-hidden" data-id="element-92">
          <motion.div animate={{
          y: [0, 48, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} className="absolute top-0 left-0 w-full h-1/2 bg-gold" data-id="element-93" />
        </div>
      </motion.div>
    </section>;
}